import {AfterViewInit, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2, ViewEncapsulation} from '@angular/core';
import {DeviceService, inOutAnimation, ScreenSize} from '@lv1871/core';
import {Subscription} from 'rxjs';
import {UIContainerControl} from '../../../models/uiArtefakt';

@Component({
    selector: 'lv-votum-box',
    templateUrl: './votum-box.component.html',
    styleUrls: ['./votum-box.component.scss'],
    animations: [inOutAnimation],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class VotumBoxComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input()
  public uiArtefakt: UIContainerControl;

  public isScreenSizeMobile: boolean;
  private _screenSizeSubscription = Subscription.EMPTY;

  public constructor(private _deviceService: DeviceService,
                     private _renderer: Renderer2, private _element: ElementRef) {
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  public ngOnInit() {
    this._screenSizeSubscription = this._deviceService.screenSize$.subscribe(screenSize => {
      this.isScreenSizeMobile = screenSize === ScreenSize.Mobile;
    });
  }

  public ngOnDestroy(): void {
    if (this._screenSizeSubscription) {
      this._screenSizeSubscription.unsubscribe();
    }
  }
}
